import ls from 'local-storage'
import router from '@/router'
import {
  SET_ACCOUNT_INFO,
  REMOVE_ACCOUNT_INFO,
  SET_LIST_PRICING,
  SET_S3_CREDENTIALS,
  SET_S3_BUCKET,
  SET_ACTIVE_PROJECT_NUMBER,
  SET_FIRST_AND_LAST_PROJECT,
  SET_INACTIVE_PROJECT_NUMBER
} from '@/store/mutation-types'

export default {
  [SET_ACCOUNT_INFO] (state, accountInfo) {
    state.accountInfo = accountInfo
    if (accountInfo.role === 'editor') {
      state.accountInfo.pricing = accountInfo.manager_pricing
      state.accountInfo.pricing.max_number_project = accountInfo.manager_pricing.editor_max_project
      state.accountInfo.pricing.max_number_scene = accountInfo.manager_pricing.editor_max_scene
    }
    if (!accountInfo.username) {
      router.push({name: 'account-username'})
    }
    state.logged = true
  },
  [REMOVE_ACCOUNT_INFO] (state, accountInfo) {
    ls.remove('authen')
    ls.remove('user')
    state.accountInfo = {}
    state.logged = false
    router.push({name: 'account-login'})
  },
  [SET_LIST_PRICING] (state, pricings) {
    state.pricings = pricings
  },
  [SET_S3_CREDENTIALS] (state, credentials) {
    state.s3Credentials = credentials
  },
  [SET_S3_BUCKET] (state, bucket) {
    state.bucket = bucket
  },
  [SET_ACTIVE_PROJECT_NUMBER] (state, value) {
    state.activeProjectNumber = value
  },
  [SET_INACTIVE_PROJECT_NUMBER] (state, value) {
    state.inactiveProjectNumber = value
  },
  [SET_FIRST_AND_LAST_PROJECT] (state, {first, last}) {
    state.firstProject = first
    state.lastProject = last
  }
}



// WEBPACK FOOTER //
// ./src/components/account/store/mutations.js